export interface Article {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  categoryName: string;
  image: string;
  imageWidth: number;
  imageHeight: number;
  date: string;
  views: number;
  isHot: boolean;
  isNew: boolean;
  isTop: boolean;
  tags: string[];
}

export const featuredArticles: Article[] = [
  {
    id: 'article-001',
    title: '某千万粉丝网红直播翻车现场全记录：人设崩塌仅用三分钟',
    excerpt: '原本一场普通的带货直播，却因为一个不经意的口误，让这位拥有三千万粉丝的顶流网红瞬间陷入舆论漩涡。现场观众录屏曝光后，话题迅速冲上热搜第一。',
    category: 'wanghong',
    categoryName: '网红翻车',
    image: 'https://readdy.ai/api/search-image?query=Breaking%20news%20dramatic%20moment%20on%20livestream%20screen%20with%20shocked%20expression%2C%20dramatic%20lighting%2C%20dark%20atmosphere%2C%20social%20media%20controversy%20concept%2C%20editorial%20style%20with%20bold%20contrast%2C%20cinematic%20composition%2C%20intense%20mood%2C%20digital%20screen%20glow&width=800&height=600&seq=gossip-hero-01&orientation=landscape',
    imageWidth: 800,
    imageHeight: 600,
    date: '2026-07-07',
    views: 1258000,
    isHot: true,
    isNew: false,
    isTop: true,
    tags: ['网红翻车', '直播事故', '人设崩塌'],
  },
  {
    id: 'article-002',
    title: '独家爆料：某顶流明星深夜密会神秘女子，酒店同框照曝光',
    excerpt: '本网独家获得一组照片，某当红顶流男星深夜与一名神秘女子在酒店同框。照片中两人举止亲密，引发粉丝热议。工作室至今未作回应。',
    category: 'celeb',
    categoryName: '明星大瓜',
    image: 'https://readdy.ai/api/search-image?query=Paparazzi%20style%20night%20photography%20of%20a%20figure%20entering%20luxury%20hotel%2C%20blurry%20candid%20shot%2C%20dramatic%20warm%20%20street%20lighting%20at%20night%2C%20mysterious%20atmosphere%2C%20celebrity%20gossip%20concept%2C%20editorial%20photography%20style%2C%20high%20contrast&width=800&height=600&seq=gossip-hero-02&orientation=landscape',
    imageWidth: 800,
    imageHeight: 600,
    date: '2026-07-06',
    views: 2380000,
    isHot: true,
    isNew: false,
    isTop: true,
    tags: ['明星大瓜', '独家爆料', '顶流塌房'],
  },
  {
    id: 'article-003',
    title: '某知名带货主播涉嫌虚假宣传被立案调查，粉丝群炸锅了',
    excerpt: '据可靠消息，某头部带货主播因涉嫌虚假宣传已被相关部门立案调查。其直播间推荐的所谓"进口高端护肤品"被证实为国内小作坊生产的三无产品。',
    category: 'hot',
    categoryName: '热门爆料',
    image: 'https://readdy.ai/api/search-image?query=Investigative%20journalism%20concept%20with%20dark%20moody%20lighting%2C%20scandal%20and%20controversy%20theme%2C%20dramatic%20atmosphere%2C%20news%20breaking%20story%2C%20forensic%20style%20lighting%20with%20shadows%2C%20tense%20editorial%20photography&width=800&height=600&seq=gossip-hero-03&orientation=landscape',
    imageWidth: 800,
    imageHeight: 600,
    date: '2026-07-06',
    views: 1890000,
    isHot: true,
    isNew: true,
    isTop: true,
    tags: ['带货翻车', '虚假宣传', '立案调查'],
  },
];

export const latestArticles: Article[] = [
  {
    id: 'article-004',
    title: '某选秀节目冠军被爆学历造假，母校澄清声明引更大争议',
    excerpt: '近期火爆的选秀节目冠军被网友扒出学历造假，其自称的"名校硕士"身份存疑。学校官方回应：该生仅为短期培训学员，并非正式注册学生。',
    category: 'celeb',
    categoryName: '明星大瓜',
    image: 'https://readdy.ai/api/search-image?query=Graduation%20diploma%20under%20investigation%20with%20magnifying%20glass%2C%20dramatic%20shadow%20lighting%2C%20academic%20scandal%20concept%2C%20mysterious%20dark%20mood%2C%20editorial%20photography%20with%20warm%20amber%20tones%2C%20clean%20background&width=600&height=450&seq=gossip-grid-01&orientation=landscape',
    imageWidth: 600,
    imageHeight: 450,
    date: '2026-07-06',
    views: 985000,
    isHot: true,
    isNew: true,
    isTop: false,
    tags: ['学历造假', '选秀冠军', '明星翻车'],
  },
  {
    id: 'article-005',
    title: '深扒某MCN机构内幕：签约网红被严苛合同压榨，违约金高达千万',
    excerpt: '多位匿名网红向本网爆料，某知名MCN机构存在严重的霸王条款问题。签约主播不仅分成比例极低，一旦提出解约还面临天价违约金索赔。',
    category: 'black-material',
    categoryName: '黑料专区',
    image: 'https://readdy.ai/api/search-image?query=Dark%20business%20contract%20with%20chain%20symbolism%2C%20dramatic%20lighting%20from%20side%2C%20corporate%20exploitation%20concept%2C%20moody%20atmosphere%2C%20editorial%20style%2C%20amber%20and%20shadow%20tones&width=600&height=450&seq=gossip-grid-02&orientation=landscape',
    imageWidth: 600,
    imageHeight: 450,
    date: '2026-07-05',
    views: 1560000,
    isHot: true,
    isNew: false,
    isTop: false,
    tags: ['MCN内幕', '霸王合同', '网红维权'],
  },
  {
    id: 'article-006',
    title: '网传某知名导演婚内出轨女演员，知情人士透露更多细节',
    excerpt: '近日，一则关于某知名已婚导演与剧组女演员关系暧昧的传闻在圈内广为流传。多位知情人士向本网证实，两人在拍摄期间确实存在超出正常合作关系的行为。',
    category: 'hot',
    categoryName: '热门爆料',
    image: 'https://readdy.ai/api/search-image?query=Film%20director%20silhouette%20with%20actress%20shadow%20on%20movie%20set%2C%20dramatic%20backlighting%2C%20scandal%20concept%2C%20moody%20cinematic%20lighting%2C%20dark%20background%20with%20warm%20highlights&width=600&height=450&seq=gossip-grid-03&orientation=landscape',
    imageWidth: 600,
    imageHeight: 450,
    date: '2026-07-05',
    views: 2100000,
    isHot: true,
    isNew: false,
    isTop: false,
    tags: ['导演出轨', '娱乐圈丑闻', '婚内出轨'],
  },
  {
    id: 'article-007',
    title: '某上市公司CEO被爆私生活混乱，多名女性联合实名举报',
    excerpt: '一则关于某知名互联网上市公司CEO私生活混乱的爆料在社交平台疯传。据称已有五名女性联合向有关部门实名举报，涉及内容令人震惊。',
    category: 'black-material',
    categoryName: '黑料专区',
    image: 'https://readdy.ai/api/search-image?query=Corporate%20executive%20silhouette%20behind%20frosted%20glass%2C%20dramatic%20office%20lighting%2C%20scandal%20investigation%20concept%2C%20dark%20moody%20atmosphere%2C%20editorial%20photography%20with%20contrast&width=600&height=450&seq=gossip-grid-04&orientation=landscape',
    imageWidth: 600,
    imageHeight: 450,
    date: '2026-07-04',
    views: 1730000,
    isHot: false,
    isNew: false,
    isTop: false,
    tags: ['CEO丑闻', '实名举报', '互联网大佬'],
  },
  {
    id: 'article-008',
    title: '网曝某综艺节目恶意剪辑制造矛盾，选手原话被严重扭曲',
    excerpt: '某热门综艺节目参赛选手在社交媒体晒出原始录音，直指节目组通过恶意剪辑制造选手之间的矛盾冲突，博取收视率。录音与播出内容的巨大差异引发网友愤慨。',
    category: 'wanghong',
    categoryName: '网红翻车',
    image: 'https://readdy.ai/api/search-image?query=TV%20show%20editing%20room%20with%20dramatic%20red%20and%20dark%20lighting%2C%20manipulation%20concept%2C%20controversy%20theme%2C%20moody%20editorial%20style%2C%20warm%20dramatic%20tones&width=600&height=450&seq=gossip-grid-05&orientation=landscape',
    imageWidth: 600,
    imageHeight: 450,
    date: '2026-07-04',
    views: 892000,
    isHot: false,
    isNew: false,
    isTop: false,
    tags: ['恶意剪辑', '综艺翻车', '造假'],
  },
  {
    id: 'article-009',
    title: '独家：某知名歌手税务问题再起波澜，补缴金额惊人',
    excerpt: '继上一轮娱乐圈税务风暴之后，又一位知名歌手被曝出存在严重的税务问题。据了解，该歌手需要补缴的税款及滞纳金高达数亿元，创下新纪录。',
    category: 'celeb',
    categoryName: '明星大瓜',
    image: 'https://readdy.ai/api/search-image?query=Financial%20documents%20on%20dark%20desk%20with%20dramatic%20lighting%2C%20tax%20investigation%20concept%2C%20moody%20atmosphere%2C%20business%20scandal%20theme%2C%20editorial%20photography%20with%20warm%20amber%20highlights&width=600&height=450&seq=gossip-grid-06&orientation=landscape',
    imageWidth: 600,
    imageHeight: 450,
    date: '2026-07-03',
    views: 3210000,
    isHot: false,
    isNew: false,
    isTop: false,
    tags: ['税务问题', '歌手翻车', '天价补税'],
  },
  {
    id: 'article-010',
    title: '某短视频平台大V因不当言论被封号，百万粉丝一夜归零',
    excerpt: '拥有500万粉丝的短视频大V因在直播中发表不当言论，账号被平台永久封禁。该大V此前多次因争议言论被警告，最终触碰平台红线，付出惨痛代价。',
    category: 'social',
    categoryName: '社会热点',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20account%20suspended%20notification%2C%20dramatic%20dark%20lighting%2C%20social%20media%20controversy%2C%20moody%20editorial%20style%2C%20warm%20dramatic%20highlights%20on%20dark%20background&width=600&height=450&seq=gossip-grid-07&orientation=landscape',
    imageWidth: 600,
    imageHeight: 450,
    date: '2026-07-03',
    views: 1450000,
    isHot: false,
    isNew: false,
    isTop: false,
    tags: ['账号封禁', '不当言论', '大V翻车'],
  },
  {
    id: 'article-011',
    title: '扒一扒某网红餐厅背后的灰色产业链，食材来源触目惊心',
    excerpt: '一家在社交平台爆火的网红餐厅被食客曝光后厨乱象，本网深入调查发现其背后存在一条完整的灰色产业链，食材来源和存储条件都令人发指。',
    category: 'black-material',
    categoryName: '黑料专区',
    image: 'https://readdy.ai/api/search-image?query=Dark%20restaurant%20kitchen%20with%20dramatic%20shadow%20lighting%2C%20food%20safety%20scandal%20concept%2C%20moody%20atmosphere%2C%20investigative%20journalism%20style%2C%20warm%20and%20dark%20contrast&width=600&height=450&seq=gossip-grid-08&orientation=landscape',
    imageWidth: 600,
    imageHeight: 450,
    date: '2026-07-02',
    views: 678000,
    isHot: false,
    isNew: false,
    isTop: false,
    tags: ['网红餐厅', '灰色产业链', '食品安全'],
  },
];

export const testimonials = [
  {
    id: 'test-001',
    name: '吃瓜群众老张',
    role: '资深吃瓜用户',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20man%20portrait%20with%20friendly%20expression%2C%20casual%20style%2C%20neutral%20gray%20background%2C%20clean%20professional%20portrait%20photography%2C%20soft%20lighting%2C%20natural%20pose&width=400&height=500&seq=testimonial-avatar-01&orientation=portrait',
    content: '吃瓜官网是我每天必刷的平台，更新速度真的快！好几次大瓜都是在这里第一时间看到的，比微博还快。现在身边的朋友都被我安利来了，大家天天蹲守等更新。',
  },
  {
    id: 'test-002',
    name: '资深瓜农小李',
    role: '平台忠实粉丝',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20with%20confident%20smile%2C%20modern%20casual%20style%2C%20neutral%20gray%20background%2C%20clean%20portrait%20photography%2C%20soft%20natural%20lighting&width=400&height=500&seq=testimonial-avatar-02&orientation=portrait',
    content: '爆料质量是真的高！不是那种捕风捉影的传闻，每条爆料都有图有真相，而且深度调查做得特别到位。黑料专区是我最喜欢的板块，每期必看。',
  },
  {
    id: 'test-003',
    name: '匿名用户007',
    role: '三年老用户',
    avatar: 'https://readdy.ai/api/search-image?query=Mysterious%20silhouette%20portrait%20in%20shadow%2C%20anonymous%20figure%2C%20dark%20atmospheric%20lighting%2C%20moody%20editorial%20style%2C%20neutral%20dark%20gray%20background&width=400&height=500&seq=testimonial-avatar-03&orientation=portrait',
    content: '关注吃瓜官网三年了，见证了无数网红从巅峰到塌房的全过程。这里的信息真实可靠，还有深度分析，不是那种标题党。现在每天不刷一下总觉得少了点什么。',
  },
];